import { Avatar, styled, Typography, useTheme } from '@mui/material';
import { type FC, useEffect, useRef, useState } from 'react';

const AvaniStyledNoFaultsMessage = styled('div')(
  () => `
  padding: 16px;
  height: 216px;
  display: flex;
  cursor: pointer;

  & .content {
    flex-grow: 1;
    padding-top: 24px;

    h2 {
      padding-bottom: 16px; 
    }
  }

  & .imageHolder {
    width: 220px;
  }
`
);

export const NoFaultsMessage: FC = () => {
  const theme = useTheme();
  const containerRef = useRef<HTMLDivElement>(null);
  const [imageSize, setImageSize] = useState(0);

  useEffect(() => {
    const element = containerRef.current;
    if (!element) return;

    const observer = new ResizeObserver(([entry]) => {
      const containerHeight = entry.contentRect.height;
      setImageSize(Math.ceil(containerHeight * 0.8));
    });

    observer.observe(element);
    return () => observer.disconnect();
  }, []);

  return (
    <AvaniStyledNoFaultsMessage ref={containerRef}>
      <div className={'content'}>
        <Typography variant={'h2'} fontSize={30} color={theme.colors.avani.lightTurc}>
          Great News!
        </Typography>
        <Typography variant={'h4'} fontSize={20} sx={{ color: 'white' }}>
          Your venue currently has no reported faults.
        </Typography>
      </div>
      <div className={'imageHolder'} style={{ alignContent: 'center' }}>
        <Avatar
          src={'/static/images/background/beer-beertenders-ok.jpg'}
          sx={{ width: imageSize, height: imageSize }}
        />
      </div>
    </AvaniStyledNoFaultsMessage>
  );
};
